<!doctype html>
<html lang="en">
  <!-- <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <link rel="preconnect" href="https://fonts.googleapis.com" />
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
    <link
      href="https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap"
      rel="stylesheet" />
  </head> -->

  <body id="pdf-data" #pdfContent>
    <div class="pdf-content">
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":"auto"}'>
          <img
            alt="Org logo"
            [src]="sheetData?.logo"
            style="width: 125px; height: auto; object-fit: contain" />
        </div>
        <div data-pdfmake='{"width":"*", "margin": [10, 0]}'>
          <div class="desc" style="text-align: right">
            {{ sheetData?.orgDetail.address }}
          </div>
          <div class="address" style="text-align: right">
            {{ sheetData?.orgDetail.city }}, {{ sheetData?.orgDetail.state }},
            {{ sheetData?.orgDetail.country }},
            {{ sheetData?.orgDetail.zipCode }}
          </div>
        </div>
      </div>

      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />

      <div data-pdfmake-type="columns">
        <div class="title" data-pdfmake='{"width":"*"}'>
          {{ sheetData?.caseDetail.student.firstName }}
          {{ sheetData?.caseDetail.student.lastName }}
        </div>
        <div style="width: auto">
          <!-- <table><tr><th>Table</th><tr><tr><td>Centered</td></tr></table> -->
        </div>
        <div
          class="title"
          style="text-align: right"
          data-pdfmake='{"width":"*"}'>
          <b>Supervisor : </b>
          {{ sheetData?.caseDetail.supervisorName || '-' }}
        </div>
      </div>

      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />

      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":"*"}'>
          <div class="datalabel">Gender</div>
          <div class="dataValue">
            <b> {{ sheetData?.caseDetail.student.gender }}</b>
          </div>
        </div>
        <div style="width: auto">
          <div class="datalabel">Student School</div>
          <div class="dataValue">
            <b>{{ sheetData?.caseDetail.student.organizationName }}</b>
          </div>
        </div>
        <div style="text-align: left" data-pdfmake='{"width":"*"}'>
          <div class="datalabel">Date Of Birth</div>
          <div class="dataValue">
            <b>{{
              sheetData?.caseDetail.student.dateOfBirth ?? null
                | date: 'MM/dd/yyyy'
            }}</b>
          </div>
        </div>
      </div>
      <br />
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":"*"}'>
          <div class="datalabel">Start Date</div>
          <div class="dataValue">
            <b>
              {{
                sheetData?.graphData?.dateRange[0] | userDate: 'MM/dd/yyyy'
              }}</b
            >
          </div>
        </div>
        <div style="width: auto">
          <div class="datalabel">End Date</div>
          <div class="dataValue">
            <b>{{
              sheetData?.graphData?.dateRange[1] | userDate: 'MM/dd/yyyy'
            }}</b>
          </div>
        </div>
        <div style="text-align: left" data-pdfmake='{"width":"*"}'></div>
      </div>
      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":147}' class="datalabel">
          <b> Category :</b>
        </div>
        <div data-pdfmake='{"width":"*"}' class="datalabel">
          <b>{{ sheetData?.behavior?.behaviorCategoryName }} </b>
        </div>
      </div>
      <br />
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":147}' class="datalabel">
          <b> Behavior :</b>
        </div>
        <div data-pdfmake='{"width":"*"}' class="datalabel">
          <b
            >{{
              sheetData?.behaviorNames?.length > 0
                ? sheetData?.behaviorNames.join(', ')
                : 'Nothing Entered'
            }}
          </b>
        </div>
      </div>
      <br />
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":147}' class="datalabel">
          Operational Definition :
        </div>
        <div data-pdfmake='{"width":"*"}' class="datalabel">
          <b
            >{{
              sheetData?.behavior.operationalDefinition || 'Nothing Entered'
            }}
          </b>
        </div>
      </div>
      <br />
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":147}' class="datalabel">Goals :</div>
        <div data-pdfmake='{"width":"*"}' class="datalabel">
          <b>{{ sheetData?.behavior.goals || 'Nothing Entered' }} </b>
        </div>
      </div>
      <br />
      <div data-pdfmake='{"width":"*"}'>
        <img
          data-pdfmake='{"width":552}'
          [src]="sheetData?.graphData.graphImage"
          [alt]="'Chart Image'"
          class="chartImage" />
      </div>
      <br />

      <div
        data-pdfmake='{"width":"*"}'
        *ngIf="sheetData?.graphData.graphImageTotal !== ''">
        <img
          data-pdfmake='{"width":552}'
          [src]="sheetData?.graphData.graphImageTotal"
          alt="Chart Image"
          class="chartImage" />
      </div>
    </div>
  </body>
</html>
